var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNav1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    role: "img",
    viewBox: "0 0 100 100",
    fill: "#70757D",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.04.73C7.64.73.8 7.57.8 15.97s6.84 15.25 15.24 15.25c8.41 0 15.25-6.84 15.25-15.25 0-8.4-6.84-15.24-15.25-15.24zm0 28.53a13.3 13.3 0 0 1 0-26.58 13.3 13.3 0 0 1 0 26.58zm1.41-5.38a1.45 1.45 0 1 1-2.9 0 1.45 1.45 0 0 1 2.9 0zm3.73-12.56c0 2.3-1.47 3.5-2.65 4.48-.94.77-1.5 1.28-1.5 1.98v1.96a.98.98 0 0 1-1.96 0v-1.96c0-1.66 1.17-2.63 2.21-3.49 1.05-.86 1.95-1.6 1.95-2.97 0-.03-.04-3.05-3.19-3.05-3.06 0-3.38 3.1-3.4 3.24a.98.98 0 1 1-1.95-.18c.17-1.74 1.5-5.02 5.35-5.02 3.77 0 5.14 3 5.14 5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNav1);
export default __webpack_public_path__ + "static/media/iconNav1.02de1f1ec3257073fcf30a895a078a25.svg";
export { ForwardRef as ReactComponent };